module.exports = __webpack_public_path__ + "img/ft.430be3fc.png";